export default __webpack_public_path__ + "media/rcap-logo.c5562d96.png";